import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../../store/actions";
import { useSelector } from "react-redux";

import "../Results.css";
import AnimationFail from "../../../../shared/components/AnimationFail";
import AnimationSuccess from "../../../../shared/components/AnimationSuccess";
import TicketHeader from "../../TicketHeader";
import ResultsButtons from "./ResultsButtons";
import ResultsAnswers from "../ResultsAnswers";
import setToLocalStorageTicketStatusArray from "../../../../shared/LocalStorageFunctions/setToLocalStorageTicketStatusArray";
import achivmentsHandler from "../../../../main/components/Achivments/achivmentsHandler";
import achivmentsAlertHandler from "../../../../shared/components/Alert/achivmentsAlertHandler";
/* import useWindowDimensions from "../../../../WindowDimensions-hook/useWindowDimensions"; */

/* import { MOBILE_WIDTH } from "../../../../constants/otherConstants"; */
import { setAlert } from "../../../../store/actions/alert";
/* import { useStore } from "../../../../hooks-store/store"; */

const Results = (props) => {

  /* const { width } = useWindowDimensions(); */

  const start = useSelector((state) => state.ticketsReducer.timerStartsAt);
  let seconds = Math.floor((Date.now() - start) / 1000)
  const deadline = useSelector((state) => state.ticketsReducer.deadline);

  /*  const state = useStore()[0]; */
  /*  const deadline = state.deadline ? state.deadline : 1200; */
  /*  const deadline = 1200; */

  const categoryTickets = props.categoryTickets;
  const reducer = (accumulator, currentValue) => {
    if (currentValue.isError) accumulator++;
    return accumulator;
  };

  const counterWrongAnswers = props.finalResultArray.reduce(reducer, 0);
  let hr = parseInt(seconds / 3600);
  let hoursFormated = pad(parseInt(seconds / 3600));
  let min;
  if (hr === 0) min = pad(parseInt(seconds / 60));
  else if (hr > 0) min = pad(parseInt((seconds - hr * 3600) / 60));

  let sec = pad(seconds % 60);

  function pad(val) {
    return val > 9 ? val : "0" + val;
  }

  const maxErrorForThemeModeCount = () => {
    return Math.round(props.finalResultArray.length / 10);
  }

  const editEnding = (num) => {
    if (num === 1) return "ошибку";
    if (num > 1 && num < 5) return "ошибки";
    if (num >= 5) return "ошибок";
    switch (num % 10) {
      case 1:
        return "ошибку";
      case 2:
        return "ошибки";
      case 3:
        return "ошибки";
      case 4:
        return "ошибки";
      case 5:
        return "ошибок";
      case 6:
        return "ошибок";
      case 7:
        return "ошибок";
      case 8:
        return "ошибок";
      case 9:
        return "ошибок";
      case 0:
        return "ошибок";
      default:
        break;
    }

  }

  const isTicketPass = () => {
    if (props.categoryTickets === "newAB" || props.categoryTickets === "newCD") {
      seconds = 0;
    }
    
    if (props.categoryTickets === "themeAB") {
      seconds = 0;
      const maxErrorCount = maxErrorForThemeModeCount();
      if (counterWrongAnswers > maxErrorCount) return false;
      else { return true };
    }
    else {
      if (counterWrongAnswers > 2 || seconds > deadline) return false;
      else { return true };
    }

  };
  const isPassed = isTicketPass();

  //Local Storage if category tickets === ticketsAB or ticketsCD
  if (categoryTickets === "ticketsAB" || categoryTickets === "ticketsCD" || categoryTickets === "themeAB") {
    setToLocalStorageTicketStatusArray(
      categoryTickets,
      isTicketPass(),
      props.currentTicket.ticketId
    );
  }

  if (categoryTickets === "examAB" || categoryTickets === "examCD") {
    let examStats = localStorage.getItem("examStats");
    if (examStats) {
      examStats = JSON.parse(examStats);
      if (isTicketPass()) {
        examStats = {
          examStatsAB: {
            failAttempts: examStats.examStatsAB.failAttempts,
            successAttemps:
              props.categoryTickets === "examAB"
                ? examStats.examStatsAB.successAttemps + 1
                : examStats.examStatsAB.successAttemps,
          },
          examStatsCD: {
            failAttempts: examStats.examStatsCD.failAttempts,
            successAttemps:
              props.categoryTickets === "examCD"
                ? examStats.examStatsCD.successAttemps + 1
                : examStats.examStatsCD.successAttemps,
          },
        };
      } else {
        examStats = {
          examStatsAB: {
            failAttempts:
              props.categoryTickets === "examAB"
                ? examStats.examStatsAB.failAttempts + 1
                : examStats.examStatsAB.failAttempts,
            successAttemps: examStats.examStatsAB.successAttemps,
          },
          examStatsCD: {
            failAttempts:
              props.categoryTickets === "examCD"
                ? examStats.examStatsCD.failAttempts + 1
                : examStats.examStatsCD.failAttempts,
            successAttemps: examStats.examStatsCD.successAttemps,
          },
        };
      }
      localStorage.setItem("examStats", JSON.stringify(examStats));
    }
  }
  useEffect(() => {
    if (categoryTickets === "examAB" || categoryTickets === "examCD") {
      props.setShouldUpdateExamStats(true);
      if (isPassed) {
        achivmentsAlertHandler(
          achivmentsHandler(["excellentKnowledge"]),
          props.setAlert
        );
      }
      achivmentsAlertHandler(
        achivmentsHandler(["hundredExams"]),
        props.setAlert
      );
    }
    else if (categoryTickets === "themeAB" || categoryTickets === "themeCD") { }
    else {
      achivmentsAlertHandler(
        achivmentsHandler([
          "niceStart",
          "keepItUp",
          "forty",
          "masterAB",
          "masterCD",
        ]),
        props.setAlert
      );
    }

    if (seconds <= 120 && isPassed && seconds !== 0) {
      achivmentsAlertHandler(achivmentsHandler(["fast"]), props.setAlert);
      if (seconds <= 60)
        achivmentsAlertHandler(
          achivmentsHandler(["superFast"]),
          props.setAlert
        );
    }
    props.setTicketStatusArray();
  }, [props, categoryTickets, isPassed, seconds]);

  return (
    <div>
      <div className="shared-card mobile-results">

        <TicketHeader
          notToRenderTimer={true}
          currentTicketHeader={props.currentTicketHeader}
        />
        <div className="results-block">
          {isTicketPass() ? <AnimationSuccess /> : <AnimationFail />}
          <div className="results-info">
            {(props.categoryTickets === "themeAB" || props.categoryTickets === "newAB" || props.categoryTickets === "newCD") ?
              ""
              : <div>
                {hr === 0 ? (
                  <p className="result-counter">{`${min} : ${sec}`}</p>
                ) : (
                  <p className="result-counter">{`${hoursFormated} : ${min} : ${sec}`}</p>
                )}
                <p className="result-label">Ваше время</p>
              </div>}

            {props.categoryTickets === "themeAB" ?
              <p className="result-label">
                {`Вы совершили ${counterWrongAnswers} ` + editEnding(counterWrongAnswers) + ' из ' + maxErrorForThemeModeCount() + " возможных"}
              </p>

              :
              <div>
                <p className="result-counter">{counterWrongAnswers}</p>
                <p className="result-label">Количество ошибок</p>
              </div>}

          </div>
          <ResultsButtons
            isPassed={isPassed}
            categoryTickets={categoryTickets}
            ticketsArray={props.ticketsArray}
          />
        </div>
      </div>
      <ResultsAnswers
        categoryTickets={props.categoryTickets}
        currentTicket={props.currentTicket}
        finalResultArray={props.finalResultArray}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTicketStatusArray: () =>
      dispatch({
        type: actionTypes.SET_TICKET_STATUS_ARRAY,
        ticketStatusArray: JSON.parse(
          localStorage.getItem("ticketStatusArray")
        )
      }),
    setShouldUpdateExamStats: (flag) =>
      dispatch({
        type: actionTypes.SET_SHOULD_UPDATE_EXAM_STATS,
        shouldUpdateExamStats: flag,
      }),
    setAlert: setAlert(dispatch),
  };
};

export default connect(null, mapDispatchToProps)(Results);
